<template>
    <q-card class="shadow-0" :class="'bg-' + color"
            :style="{ 'max-width': width, 'width': $q.screen.gt.sm ? '90vw': '100%'}">
        <q-card-title v-if="title || $slots.title"
                      :class="['bg-' + titleColor, {'text-light': titleInverted, 'text-dark': !titleInverted }]">
            <slot name="title">
                {{ title | capitalize }}
                <q-icon v-if="icon" slot="right" :color="titleInverted ? 'light' : 'dark'"
                        :name="icon"></q-icon>
            </slot>
            <template slot="subtitle">
                <slot name="subtitle"></slot>
            </template>
        </q-card-title>
        <q-card-main>
            <slot></slot>
        </q-card-main>
        <q-card-actions v-if="$slots.actions" align="center" :class="'bg-' + footerColor">
            <slot name="actions"></slot>
        </q-card-actions>
    </q-card>
</template>

<script>
    import {
        QCard,
        QCardTitle,
        QCardMain,
        QCardActions,
        QIcon
    } from 'quasar-framework'

    export default {
        name: 'Card',

        props: {
            title: {
                type: String
            },
            titleColor: {
                type: String,
                default: 'light'
            },
            titleInverted: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String
            },
            color: {
                type: String,
                default: 'white'
            },
            width: {
                type: String,
                default: '400px'
            },
            footerColor: {
                type: String,
                default: 'light'
            }
        },

        components: {
            QCard,
            QCardTitle,
            QCardMain,
            QCardActions,
            QIcon
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Card.vue